<template>
  <div sliderTumbs :class="type">
    <div class="visual-main">
      <div class="swiper main">
        <div class="swiper-wrapper">
          <slot />
        </div>
        <div class="swiper-navigation" v-if="navigation">
          <a class="swiper-button-prev" />
          <a class="swiper-button-next" />
        </div>
      </div>
    </div>
    <div class="visual-sub">
      <div class="swiper sub">
        <div class="swiper-wrapper">
          <slot />
        </div>
        <div class="swiper-navigation" v-if="navigation">
          <a class="swiper-button-prev" />
          <a class="swiper-button-next" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
@import "~@/less/proj";

[sliderTumbs] {
  .rel;
  .pb(150);

  .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .swiper-slide {
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .swiper-navigation {
    .abs;
    .flex;
    justify-content: center;
    width: 100%;
    .b(80);

    .swiper-button-prev,
    .swiper-button-next {
      .static;
      .wh(30);
      margin-top: 0;
      .-a(#4e4e4e);
      .-box;

      &:after {
        .wh(16);
        .bg("@{dc_sj}/arrow-next.svg");
        .no-repeat;
        .cover;
      }

      &:hover {
        .bgc(#4e4e4e);

        &.swiper-button-disabled {
          .bgc(transparent);
        }
      }
    }

    .swiper-button-prev {
      &:after {
        .bg("@{dc_sj}/arrow-prev.svg");
      }
    }

    .swiper-button-next {
      .ml(14);
    }
  }

  .visual-main {
    .txt {
      .mt(20);
      .p(0, 20);

      p {
        .fs(16, 26, -.5);
      }
    }

    .img {
      .vw-h(240, 375);
      .p(0, 20);
    }

    .main {
      height: 80%;
      width: 100%;
      .mt(40);
    }
  }

  .visual-sub {
    display: none;

    .swiper-slide {
      .pointer;
    }
    .txt {
      .hide;
    }
  }
}

@media (min-width: @screen-md-min) {
  [sliderTumbs] {
  .pb(100);

    .visual-main {
      .main {
        margin-top: 0;

        .swiper-navigation {
          .hide;
        }
      }

      .img {
        .p(0, 69);
        height: auto;
      }

      .txt {
        .mt(16);
        .p(0, 69);
      }
    }

    .visual-sub {
      .rel;
      .block;
      .mt(40);
      .p(0, 69);

      .sub {
        .img {
          .vw-h(90, 768);
        }
        .swiper-navigation {
          top: 50%;
          left: 0;
          right: 0;
          .h(30);
          .yc;

          .swiper-button-prev,
          .swiper-button-next {
            .abs;
            top: 0;
            left: 0;
            .l(24);
          }

          .swiper-button-next {
            margin-left: 0;
            left: auto;
            .r(24);
          }
        }
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [sliderTumbs] {
    .visual-main {
      .img,
      .txt {
        .p(0, 100);
      }
      .txt {
        .mt(20);
      }
    }

    .visual-sub {
      .mt(50);
      .p(0, 100);

      .sub {
        .swiper-navigation {
          .h(40);

          .swiper-button-prev,
          .swiper-button-next {
            .wh(40);

            &:after {
              .wh(18);
            }
          }

          .swiper-button-prev {
            .l(40);
          }

          .swiper-button-next {
            .r(40);
          }
        }
      }
    }
  }
}

@media (min-width: @screen-xxl-min) {
  [sliderTumbs] {
    .visual-main {
      .img, .txt {
        .max-w(1336);
        margin: 0 auto;
        padding: 0;
      }

      .txt {
        .mt(20);
        padding: 0;
        p {
          .fs(24, 1.58);
          .ls(-1.5);
        }
      }
    }

    .visual-sub {
      .max-w(1336);
      margin: 0 auto;
      .mt(60);
      padding: 0;

      .sub {
        .img {
          .vw-h(130, 1600);
        }
        .swiper-navigation {
          .swiper-button-prev {
            .l(-72)
          }
  
          .swiper-button-next {
            .r(-72)
          }
        }
      } 
    }
  }
}
</style>

<script>
import Swiper from "swiper";

export default {
  name: "SliderTumbs",
  props: {
    pagination: { default: true },
    navigation: { default: false },
    useThumbs: { type: Boolean, default: false },
    option: Object,
    type: String,
    html: { default: "" },
    text: { type: String, default: "" },
  },
  data() {
    return {
      slider: null,
    };
  },
  mounted() {
    if (!this.useThumbs) this.init();
  },
  beforeDestroy() {
    if (this.slider) this.slider.destroy();
  },
  methods: {
    init() {
      const visualSub = new Swiper(".sub", {
        watchSlidesVisibility: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 14,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1600: {
            spaceBetween: 20,
            slidesPerView: 6,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      // eslint-disable-next-line no-unused-vars
      const visualMain = new Swiper(".main", {
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: visualSub,
        },
        breakpoints: {
          768: {
            allowTouchMove: false,
          },
        },
      });
    },
  },
};
</script>
